import React from "react";
//#region types
import { SalaryDeviationReportFooterProps } from "models/propTypes/salaryDeviationPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import SalaryDeviationFooter from "./footer";
import { useSalaryDeviationsService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";

const SalaryDeviationReportFooter: React.FC<SalaryDeviationReportFooterProps> = (props) => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const { deviationMonth, isAllowedToSubmit, reloadList } = props;

  const isTimeReportingEnabled = CompanyService.isTimeReportingEnabled();
  const hasSalaryAdminPermission = salaryDeviationsService.hasAdminPermissions();

  return isAllowedToSubmit && deviationMonth && !isTimeReportingEnabled && hasSalaryAdminPermission ? (
    <SalaryDeviationFooter
      salaryDeviationReport={{
        id: deviationMonth.id,
        yearMonth: deviationMonth.yearAndMonth,
        reportMonthLastDate: DateHelper.getLastDayOfMonth(DateHelper.getDateFromYearMonth(deviationMonth.yearAndMonth)),
      }}
      overrideApproveButtonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.Submit)}
      markAsDoneHandler={reloadList}
    />
  ) : (
    <></>
  );
};

export default SalaryDeviationReportFooter;
